import Vue from 'vue';
import Router from 'vue-router';

// eslint-disable-next-line no-unused-vars
import { store } from './store';

import Home from './pages/Home/Home.vue';
import Products from './pages/Products/Products.vue';
import Checkout from './pages/Checkout/Checkout.vue';
import Login from './pages/Login/Login.vue';
import Orders from './pages/Orders.vue';
import Account from './pages/Account/Account.vue';
import Register from './pages/Register.vue';
import ForgotPassword from './pages/ForgotPassword.vue';
import About from './pages/About.vue';
import Help from './pages/Help/Help.vue';
import ValidateEmail from './pages/ValidateEmail.vue';
import ProfileViviana from './pages/ProfileViviana.vue';

Vue.use(Router);

let router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {path: '/', name: 'Home', component: Home},
        {path: '/products/:id?', name: 'Products', component: Products},
        {path: '/about', name: 'About', component: About},
        {path: '/help/:section?', name: 'Help', component: Help },

        {path: '/register', name: 'Register', component: Register},
        {path: '/login', name: 'Login', component: Login},
        {path: '/logout', name: 'Logout'},
        {path: '/forgot', name: 'ForgotPassword', component: ForgotPassword},
        {path: '/validate', name: 'ValidateEmail', component: ValidateEmail},

        {path: '/checkout', name: 'Checkout', component: Checkout, meta: {requiresAuth: true}},
        {path: '/account', name: 'Account', component: Account, meta: {requiresAuth: true}},
        {path: '/orders', name: 'Orders', component: Orders, meta: {requiresAuth: true}},
        
        {path: '/viviana-novelle', name: 'ProfileViviana', component: ProfileViviana }
    ]
});

// Initial data load required for any part of the app
router.beforeEach(async (to, from, next) => {
    // Scroll to top
    window.scrollTo(0,0);

    await router.app.$store.dispatch('parameters/fetch');
    await router.app.$store.dispatch('cart/get');

    if(!router.app.$store.getters['user/isAuthenticated']) {
        if(to.matched.some(e => e.meta.requiresAuth)) {
            next({
                path: '/login',
                query: {redirect: to.fullPath}
            })
        }
        else {
            next();
        }
    }
    else
    {
        if(!router.app.$store.getters['customer/isLoaded']) {
            await router.app.$store.dispatch('customer/fetch', router.app.$store.getters['user/get'].customer_id);
            await router.app.$store.dispatch('customer/fetchShippingAddresses');
            await router.app.$store.dispatch('customer/fetchBillingAddresses');

            let customer = router.app.$store.getters['customer/get']();            
            let cart = router.app.$store.getters['cart/get']();

            if (cart && customer && !cart.customer) {
                await router.app.$store.dispatch('cart/setCustomer', {
                    customer: customer
                });
            }
        }
    
        next();
    }
});

export default router;